import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import type { PurchaseOrder } from '@ztechapps/common.contract'
import { DataListRow } from './DataListRow'

export const ListRow = (props: BodyRowConfig<EntityWithSelection<PurchaseOrder>>) => {
  return (
    <>
      <RowNumberBodyCell {...props} />

      <DataListRow {...props} />
    </>
  )
}
